import SupplierOnlyDownInvAPI from '../../api/SupplierOnlyDownInvAPI';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';
export default {
	deleteSupOnlyDown: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: SupplierOnlyDownInvAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/remove-suponlydowninv',
			data: payload
		});
		return res;
	},

	addSupOnlyDown: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: SupplierOnlyDownInvAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				data: payload
			},
			true
		);
		return res;
	},

	getPagingSupOnlyDown: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: SupplierOnlyDownInvAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				params: payload
			},
			true
		);
		if (res && res.Success) {
			context.commit('setData', res.Data);
		}
		return res;
	},

	getTotalRecordSupOnlyDown: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: SupplierOnlyDownInvAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/total'
			},
			true
		);
		if (res && res.Success) {
			context.commit('setTotalPage', res.Data);
		}
		return res;
	}
};
